<div class="container-fluid">
    <img style='cursor: pointer;' (click)='openImagePopup()' [src]='imgURL+imgPath'>
</div>
